var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-information container-32"},[_c('div',{staticClass:"payment-information__total"},[_c('div',{staticClass:"tp-text-subtitle"},[_vm._v(" "+_vm._s(_vm.$t('screens.order.orderTotalAmount'))+" ")]),_c('div',{staticClass:"tp-text-subtitle"},[_vm._v(" "+_vm._s(_vm.orderTotalFormatted)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }